import { TrackingController } from "./controllers/TrackingController";
import { UiController } from "./controllers/UiController";
import { initGlobalUtils } from "./utils/globalUtils";

const main = () => {
  window.version = window["main"].getAttribute("data-version");
  window.gtmEnabled = window["main"].getAttribute("data-gtm") === "true";
  console.log("version", window.version);
  initGlobalUtils();

  waitFor('trackingBtn', () => {
    TrackingController.init();
  });
  waitFor('trademark', () => {
    UiController.init();
  });
};

main();
